<!--<snack-bar-container>-->
  <!--<ng-template>-->
    <span class="example-pizza-party">
      Pizza party!!! 🍕
    </span>
  <!--</ng-template>-->
<!--</snack-bar-container>-->
